define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAgent = require('web-agent-assets-js/lpAgent');
    var AuthenticationChat = require('web-agent-assets-js/lpAuthChat');
    var AgentSessionVisit = require('web-agent-assets-js/lpAgentSessionVisit');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpSdeDataHandler = require('web-agent-assets-js/lpSdeDataHandler');

    var lpAgentSessionVisitController = function (model, config) {
        this.applicationType = "lpAgentSessionVisitController";
        var logger = WebAgentLogger.getLogger(this.applicationType);
        var agentSessionVisitApi, authenticationChatApi;
        var visitSessionKeyCallbackFunction = {};
        var customVariableNames = {
            prechat: 'preChat',
            postchat: 'postChat',
            offline: 'offlineSurvey',
            operator: 'agentSurvey'
        };

        var namedPreChatQuestions = {
            prechatNamedQuestions: 'preChatNamedQuestions',
            identifier: 'identifier',
            phoneNumber: 'phoneNumber',
            email: 'email'
        };

        var excludeCustomVariableNames = [
            'survey_exit',
            'API Application Name',
            'LPContainerId',
            'LP visitor category',
            'API Application Key'
        ];

        this.getAppServerData = function (data) {
            checkMyEngagement(data);
        };

        initializeApi();

        function initializeApi() {
        }

        function initializeAgentSessionVisitApi() {
            var baseUrl = lpAgent.sessionDataManager.getSessionData('lpAgentRel');
            if (baseUrl) {
                agentSessionVisitApi = new AgentSessionVisit(baseUrl);
                authenticationChatApi = new AuthenticationChat(baseUrl);

            }
        }

        /////////////////////////////// APP SERVER DATA ///////////////////////////////////

        /**
         * Requests the app server data based on the visit session key - if this is in my engagements.
         * If it's in my engagements - we can get the visit session key based on the chat ID.
         * If not - we request the data according to visitor ID only.
         * @param data - JSON containing visitor ID and chat ID.
         */
        function checkMyEngagement(data) {
            var visitorId, chatId;
            if (data) {
                visitorId = data.visitorId;
                chatId = data.chatId;
            }
            if (visitorId) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                if (model.get(participantPath)) {
                    // If this is my engagement - we bind to the visit session key
                    var modelPath;
                    // If we can bind accurately according to the chat ID - great. If not - just use the visit session key
                    if (chatId) {
                        modelPath = participantPath + '.visitSessionKeys.' + chatId;
                    } else {
                        modelPath = participantPath + '.participantInfo.visitSessionKey';
                    }
                    visitSessionKeyCallbackFunction[visitorId + ''] = lpUtils.callbackContextWrapper(onVisitSessionKey, data);
                    model.bind(modelPath, visitSessionKeyCallbackFunction[visitorId + '']);
                } else {
                    // If not - we just try to send the request with the current data
                    getAppServerData(data);
                }
            }
        }

        function onVisitSessionKey(data) {
            var visitSessionKey, context, visitorId;
            if (data && data.newValue) {
                visitSessionKey = data.newValue;
                context = data.context;
                if (context) {
                    visitorId = context.visitorId;
                }
            }
            if (visitorId && context) {
                model.unbind(data.key, visitSessionKeyCallbackFunction[visitorId + '']);
                visitSessionKeyCallbackFunction[visitorId + ''] = null;
                delete visitSessionKeyCallbackFunction[visitorId + ''];
            }
            if (context && visitSessionKey) {
                context.visitSessionKey = visitSessionKey;
                getAppServerData(context);
            }
        }

        function getAppServerData(data) {
            logger.debug("","getAppServerData", data);
            var appServerVisitorId, visitorId, visitSessionKey;
            if (data) {
                visitorId = data.visitorId;
                appServerVisitorId = data.appServerVisitorId;
                visitSessionKey = data.visitSessionKey;
            }
            if (!agentSessionVisitApi) {
                initializeAgentSessionVisitApi();
            }
            if (agentSessionVisitApi && appServerVisitorId && visitorId) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleAgentSessionVisitDataSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleAgentSessionVisitDataError, data),
                    context: data
                };

                    agentSessionVisitApi.getVisit(requestObj, appServerVisitorId, visitSessionKey);
                    getAuthChat(data, visitorId, model.get('participants.myEngagements.' +visitorId+ '.participantInfo.participantId'));

            }
        }
        function getAuthChat(data, visitorId, participantId){
            if(!participantId) {
                return;
            }
            data.participantId = participantId;
            var requestObj = {
                success: lpUtils.callbackContextWrapper(handleAuthChatDataSuccess, data),
                error: lpUtils.callbackContextWrapper(handleAuthChatDataError, data),
                context: data
            };

            var modelData = model.get(lpAgentSessionVisitController.prototype.serviceNames.authenticated + '.data.' + participantId);
            if (modelData) {
                lpAgentSessionVisitController.prototype.addDataObjectToVisitorInfo(model, {visitorId: visitorId, participant: modelData});
            } else {
                lpAgentSessionVisitController.prototype.addServiceToRequestedServices(lpAgentSessionVisitController.prototype.serviceNames.authenticated, undefined, model);
                authenticationChatApi.getAuthChat(requestObj, visitorId, participantId);
                lpAgentSessionVisitController.prototype.addDataObjectToVisitorInfo(model, {visitorId: visitorId, participant: {id: participantId}});
            }
        }

        function handleAuthChatDataSuccess(data) {
            var context = data && data.context;
            lpAgentSessionVisitController.prototype.handleACRequestSuccess(model, data, lpAgentSessionVisitController.prototype.serviceNames.authenticated, getSingleAuthenticateObject, context);

        }

        function handleAuthChatDataError(data) {
            var context = data && data.context;
            if (data.statusCode === 404 && authenticationChatApi.isNewApi()) {
                authenticationChatApi.moveToOldAuthApi();
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleAuthChatDataSuccess, context),
                    error: lpUtils.callbackContextWrapper(handleAuthChatDataError, context)
                };
                authenticationChatApi.getAuthChat(requestObj, context.visitorId, context.participantId);
            } else {
                lpAgentSessionVisitController.prototype.handleRequestError(model, data, lpAgentSessionVisitController.prototype.serviceNames.authenticated, data && data.visitorId);
            }
        }
        function getSingleAuthenticateObject(authenticateObject) {
            var toReturn = {
                customerInfo: lpUtils.cloneObject(authenticateObject.authenticatedParticipantInfo || authenticateObject),
                personalInfo: lpUtils.cloneObject(authenticateObject.authenticatedPersonalInfo)
            };
            var visitorId = this.visitorId;
            toReturn = parseSdeForAuth(toReturn);
            toReturn.id = this.participantId;
            toReturn.isAuthenticated = true;
            lpAgentSessionVisitController.prototype.addToVisitorInfoById(model, 'participant', toReturn, visitorId, undefined, lpAgentSessionVisitController.prototype.serviceNames.authenticated);
            return toReturn;
        }

        function parseSdeForAuth(data) {
            return {
                customerInfo: lpSdeDataHandler.getProcessedCustomerInfoEvent(data),
                personalInfo: lpSdeDataHandler.getProcessedPersonalInfoEvent(data)
            };
        }

        function handleAgentSessionVisitDataSuccess(data) {
            logger.info("AgentSessionVisitData return as success", "handleAgentSessionVisitDataSuccess");
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            var dataToUse = getDataToUse(data);
            if (data && dataToUse) {
                for (var index = 0; index < dataToUse.length; index++) {
                    if (dataObject && dataObject.data && dataObject.data.visitorId) {
                        dataToUse[index].visitorId = dataObject.data.visitorId;
                    }
                    var processedItem = getSingleAgentSessionVisitObject(dataToUse[index]);
                    lpAgentSessionVisitController.prototype.addDataObjectToVisitorInfo(model, processedItem, lpAgentSessionVisitController.prototype.serviceNames.agentSessionVisit);
                }
            }

            function getDataToUse(data) {
                var dataToUse = [];
                if (data && data.body) {
                    var temp = data.body;
                    if (temp && temp.visitIds) {
                        temp = temp.visitIds;
                    }
                    if (temp && temp.visitId) {
                        dataToUse = temp.visitId;
                    }
                    if (dataToUse.constructor !== Array) {
                        dataToUse = [dataToUse];
                    }
                    temp = null;
                }
                return dataToUse;
            }
        }

        function handleAgentSessionVisitDataError(data) {
            logger.warn("", "handleAgentSessionVisitDataError", data);
            var context = data && data.context;
            var obj = {
                visitorId: context.visitorId
            };
            var processedItem = getSingleAgentSessionVisitObject(obj);
            lpAgentSessionVisitController.prototype.addDataObjectToVisitorInfo(model, processedItem, lpAgentSessionVisitController.prototype.serviceNames.agentSessionVisit, undefined, 'error');
        }

        function getSingleAgentSessionVisitObject(data) {
            var toReturn = {};
            if (data) {
                var flattennedData = {
                    visitorId: data.visitorId
                };
                if (data.visitInfo) {
                    if (data.visitInfo.visitorId) {
                        flattennedData.appServerVisitorId = data.visitInfo.visitorId;
                    }
                    handleInfo(data.visitInfo.sessionInfo, flattennedData);
                    handleInfo(data.visitInfo.visitorInfo, flattennedData);
                    handleInfo(data.visitInfo.time, flattennedData);
                }
                //This requires implementing getModelParam
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(flattennedData.visitorId);
                var modelPath = participantPath + ".participantInfo";
                var modelData = model.get(modelPath);
                if (!modelData) {
                    modelPath = "participants.visitorList.data." + flattennedData.visitorId + ".participantInfo";
                    modelData = model.get(modelPath);
                }

                var chatModel = model.get("chats." + lpTag.WebAgent.logicController.getLatestChatId(participantPath));

                if(chatModel && chatModel.agentInfo) {
                    modelData.displayName = chatModel.agentInfo.agentName || modelData.displayName;
                    modelData.agentId = chatModel.agentInfo.agentId || modelData.agentId;
                }

                toReturn = lpBaseInfoController.prototype.createCommonInfoDataObject(modelData, flattennedData.visitorId);
                toReturn = lpBaseInfoController.prototype.createCommonInfoDataObject(flattennedData, flattennedData.visitorId, toReturn);
                toReturn.visitSessionKey = data.visitSessionKey;
                if (data.pages && data.pages.page) {
                    toReturn.pages = [];
                    toReturn.pages = lpBaseInfoController.prototype.handlePages(data.pages.page, pageTransformer);
                    data.pages = null;
                    delete data.pages;
                }
                if (data.customVariables && data.customVariables.customVariable) {
                    handleCustomVariables(data.customVariables.customVariable, toReturn);
                }
                if (data.operatorAlerts && data.operatorAlerts.operatorAlert) {
                    toReturn.operatorAlerts = data.operatorAlerts.operatorAlert.constructor === Array ? data.operatorAlerts.operatorAlert : [data.operatorAlerts.operatorAlert] ;
                }
                if (!toReturn.rtSessionId) {
                    var chatId = lpTag.WebAgent.logicController.getChatIdFromVisitorId(data.visitorId);
                    if (chatId) {
                        toReturn.rtSessionId = chatId;
                        toReturn.engagementId = chatId;
                    }
                }
                toReturn.employeeId = model.get('agent.employeeId');
                var chatData = model.get('chats.' + toReturn.rtSessionId);
                if (chatData && chatData.chatInfo && chatData.chatInfo.startTime) {
                    toReturn.chatRequestTime = new Date(chatData.chatInfo.startTime).getTime();
                }
                if (chatData && chatData.chatInfo && chatData.chatInfo.state) {
                    if (!toReturn.currentChatState) {
                        toReturn.currentChatState = chatData.chatInfo.state;
                    }
                }
                toReturn.accountId = model.get('account');
            }
            return toReturn;
        }

        function pageTransformer(page) {

            var url, title, startTime;

            title = page.title;
            startTime = page.time;
            url = page.url;

            return {
                url: url,
                title: title,
                startTime: startTime
            };

        }

        function handleCustomVariables(data, collection) {
            if (data && data.length && collection) {
                for (var name in customVariableNames) {
                    collection[customVariableNames[name]] = [];
                }
                collection[namedPreChatQuestions.prechatNamedQuestions] = {};
                for (var index = 0; index < data.length; index++) {
                    if (data[index]) {
                        var source = getProperty(data[index], 'source');
                        if (source) {
                            if (customVariableNames && customVariableNames[source]) {
                                var questionName = getProperty(data[index], 'name');
                                if (questionName && customVariableNames[source] === customVariableNames.prechat && namedPreChatQuestions && namedPreChatQuestions[questionName]) {
                                    collection[namedPreChatQuestions.prechatNamedQuestions][namedPreChatQuestions[questionName]] = data[index];
                                } else {
                                    collection[customVariableNames[source]].push(data[index]);
                                }
                            } else if (source === 'chattag' && data[index].displayName.toLowerCase() === 'skill') {
                                collection.skill = data[index].value;
                            } else if (data[index].displayName.toLowerCase() === 'async' && data[index].value == "true") { // Catch the async chat UDE value and change the chatState.
                                collection.chatState = agentLEManager.translateLE('LEWebAgent.' + "Messaging_session");
                                collection.async = true;
                            } else {
                                handleGeneralCustomVariable(data[index], collection);
                            }
                        }
                    }
                }
            }
        }

        function handleGeneralCustomVariable(customVariable, collection) {
            if (customVariable && collection && customVariable.displayName) {
                var source = getProperty(customVariable, 'source');
                if (source) {
                    if (!collection.customVariables) {
                        collection.customVariables = [];
                    }
                    if (source === "monitortag" && customVariable.displayName === "visitorActive") {
                        return;
                    }
                    if (excludeCustomVariableNames.indexOf(customVariable.displayName) >= 0) {
                        return;
                    }
                    var index = _.findIndex(collection.customVariables, function (item) {
                        return getProperty(item, 'name') === getProperty(customVariable, 'name');
                    });
                    if (index >= 0) {
                        collection.customVariables[index] = customVariable;
                    } else {
                        collection.customVariables.push(customVariable);
                    }
                }
            }
        }

        function handleInfo(data, toReturn) {
            if (data && data.info) {
                var array = data.info;
                if (array.constructor !== Array) {
                    array = [array];
                }
                for (var index = 0; index < array.length; index++) {
                    var item = array[index];
                    var name = getProperty(item, 'name');
                    if (item && name && typeof item.$ !== 'undefined') {
                        toReturn[name] = item.$;
                    }
                }
            }
        }

        function getProperty(data, name) {
            return data[name] || data['@' + name];
        }
    };
    lpAgentSessionVisitController.prototype = new lpBaseInfoController();

    return lpAgentSessionVisitController;

});
